import { render, staticRenderFns } from "./property-ad-card.vue?vue&type=template&id=0cf11daa&scoped=true&"
import script from "./property-ad-card.vue?vue&type=script&lang=js&"
export * from "./property-ad-card.vue?vue&type=script&lang=js&"
import style0 from "./property-ad-card.vue?vue&type=style&index=0&id=0cf11daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf11daa",
  null
  
)

/* custom blocks */
import block0 from "../../../lang/components/search/property-ad-card.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fforge%2Fplacy.live%2Fresources%2Fassets%2Fjs%2Fcomponents%2Fsearch%2Fproperty-ad-card.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports